function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import EventEmitter from 'eventemitter3';
import { d as defaultChains } from './chains-fd2c546c.esm.js';

function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

function _classPrivateMethodInitSpec(obj, privateSet) {
  _checkPrivateRedeclaration(obj, privateSet);

  privateSet.add(obj);
}

function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);

  privateMap.set(obj, value);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }

  return descriptor.value;
}

function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }

  return privateMap.get(receiver);
}

function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");

  return _classApplyDescriptorGet(receiver, descriptor);
}

function _classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return fn;
}

function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }

    descriptor.value = value;
  }
}

function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");

  _classApplyDescriptorSet(receiver, descriptor, value);

  return value;
}

function normalizeChainId(chainId) {
  if (typeof chainId === 'string') return Number.parseInt(chainId, chainId.trim().substring(0, 2) === '0x' ? 16 : 10);
  if (typeof chainId === 'bigint') return Number(chainId);
  return chainId;
}
/**
 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors per EIP-1474.
 * @see https://eips.ethereum.org/EIPS/eip-1474
 */


var RpcError = /*#__PURE__*/function (_Error) {
  _inherits(RpcError, _Error);

  var _super = _createSuper(RpcError);

  function RpcError(
  /** Number error code */
  code,
  /** Human-readable string */
  message,
  /** Low-level error */
  internal,
  /** Other useful information about error */
  data) {
    var _this;

    _classCallCheck(this, RpcError);

    if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
    if (!message || typeof message !== 'string') throw new Error('"message" must be a nonempty string.');
    _this = _super.call(this, message);

    _defineProperty(_assertThisInitialized(_this), "code", void 0);

    _defineProperty(_assertThisInitialized(_this), "data", void 0);

    _defineProperty(_assertThisInitialized(_this), "internal", void 0);

    _this.code = code;
    _this.data = data;
    _this.internal = internal;
    return _this;
  }

  return RpcError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Error subclass implementing Ethereum Provider errors per EIP-1193.
 * @see https://eips.ethereum.org/EIPS/eip-1193
 */


var ProviderRpcError = /*#__PURE__*/function (_RpcError) {
  _inherits(ProviderRpcError, _RpcError);

  var _super2 = _createSuper(ProviderRpcError);

  /**
   * Create an Ethereum Provider JSON-RPC error.
   * `code` must be an integer in the 1000 <= 4999 range.
   */
  function ProviderRpcError(
  /**
   * Number error code
   * @see https://eips.ethereum.org/EIPS/eip-1193#error-standards
   */
  code,
  /** Human-readable string */
  message,
  /** Low-level error */
  internal,
  /** Other useful information about error */
  data) {
    _classCallCheck(this, ProviderRpcError);

    if (!(Number.isInteger(code) && code >= 1000 && code <= 4999)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    return _super2.call(this, code, message, internal, data);
  }

  return ProviderRpcError;
}(RpcError);

var AddChainError = /*#__PURE__*/function (_Error2) {
  _inherits(AddChainError, _Error2);

  var _super3 = _createSuper(AddChainError);

  function AddChainError() {
    var _this2;

    _classCallCheck(this, AddChainError);

    _this2 = _super3.apply(this, arguments);

    _defineProperty(_assertThisInitialized(_this2), "name", 'AddChainError');

    _defineProperty(_assertThisInitialized(_this2), "message", 'Error adding chain');

    return _this2;
  }

  return AddChainError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ChainDoesNotSupportMulticallError = /*#__PURE__*/function (_Error3) {
  _inherits(ChainDoesNotSupportMulticallError, _Error3);

  var _super4 = _createSuper(ChainDoesNotSupportMulticallError);

  function ChainDoesNotSupportMulticallError(_ref) {
    var _this3;

    _classCallCheck(this, ChainDoesNotSupportMulticallError);

    var blockNumber = _ref.blockNumber,
        chain = _ref.chain;
    _this3 = _super4.call(this, "Chain \"".concat(chain.name, "\" does not support multicall").concat(blockNumber ? " on block ".concat(blockNumber) : '', "."));

    _defineProperty(_assertThisInitialized(_this3), "name", 'ChainDoesNotSupportMulticall');

    return _this3;
  }

  return ChainDoesNotSupportMulticallError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ChainMismatchError = /*#__PURE__*/function (_Error4) {
  _inherits(ChainMismatchError, _Error4);

  var _super5 = _createSuper(ChainMismatchError);

  function ChainMismatchError(_ref2) {
    var _this4;

    _classCallCheck(this, ChainMismatchError);

    var activeChain = _ref2.activeChain,
        targetChain = _ref2.targetChain;
    _this4 = _super5.call(this, "Chain mismatch: Expected \"".concat(targetChain, "\", received \"").concat(activeChain, "."));

    _defineProperty(_assertThisInitialized(_this4), "name", 'ChainMismatchError');

    return _this4;
  }

  return ChainMismatchError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ChainNotConfiguredError = /*#__PURE__*/function (_Error5) {
  _inherits(ChainNotConfiguredError, _Error5);

  var _super6 = _createSuper(ChainNotConfiguredError);

  function ChainNotConfiguredError() {
    var _this5;

    _classCallCheck(this, ChainNotConfiguredError);

    _this5 = _super6.apply(this, arguments);

    _defineProperty(_assertThisInitialized(_this5), "name", 'ChainNotConfigured');

    _defineProperty(_assertThisInitialized(_this5), "message", 'Chain not configured');

    return _this5;
  }

  return ChainNotConfiguredError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ConnectorAlreadyConnectedError = /*#__PURE__*/function (_Error6) {
  _inherits(ConnectorAlreadyConnectedError, _Error6);

  var _super7 = _createSuper(ConnectorAlreadyConnectedError);

  function ConnectorAlreadyConnectedError() {
    var _this6;

    _classCallCheck(this, ConnectorAlreadyConnectedError);

    _this6 = _super7.apply(this, arguments);

    _defineProperty(_assertThisInitialized(_this6), "name", 'ConnectorAlreadyConnectedError');

    _defineProperty(_assertThisInitialized(_this6), "message", 'Connector already connected');

    return _this6;
  }

  return ConnectorAlreadyConnectedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ConnectorNotFoundError = /*#__PURE__*/function (_Error7) {
  _inherits(ConnectorNotFoundError, _Error7);

  var _super8 = _createSuper(ConnectorNotFoundError);

  function ConnectorNotFoundError() {
    var _this7;

    _classCallCheck(this, ConnectorNotFoundError);

    _this7 = _super8.apply(this, arguments);

    _defineProperty(_assertThisInitialized(_this7), "name", 'ConnectorNotFoundError');

    _defineProperty(_assertThisInitialized(_this7), "message", 'Connector not found');

    return _this7;
  }

  return ConnectorNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ContractMethodNoResultError = /*#__PURE__*/function (_Error8) {
  _inherits(ContractMethodNoResultError, _Error8);

  var _super9 = _createSuper(ContractMethodNoResultError);

  function ContractMethodNoResultError(_ref3) {
    var _this8;

    _classCallCheck(this, ContractMethodNoResultError);

    var addressOrName = _ref3.addressOrName,
        blockExplorer = _ref3.blockExplorer,
        functionName = _ref3.functionName;
    _this8 = _super9.call(this, ["Function \"".concat(functionName, "\" on contract \"").concat(addressOrName, "\" returned an empty response."), '', "Are you sure the function \"".concat(functionName, "\" exists on this contract?")].concat(_toConsumableArray(blockExplorer ? ['', "".concat(blockExplorer === null || blockExplorer === void 0 ? void 0 : blockExplorer.name, ": ").concat(blockExplorer === null || blockExplorer === void 0 ? void 0 : blockExplorer.url, "/address/").concat(addressOrName, "#readContract")] : [])).join('\n'));

    _defineProperty(_assertThisInitialized(_this8), "name", 'ContractMethodNoResultError');

    return _this8;
  }

  return ContractMethodNoResultError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProviderChainsNotFound = /*#__PURE__*/function (_Error9) {
  _inherits(ProviderChainsNotFound, _Error9);

  var _super10 = _createSuper(ProviderChainsNotFound);

  function ProviderChainsNotFound() {
    var _this9;

    _classCallCheck(this, ProviderChainsNotFound);

    _this9 = _super10.apply(this, arguments);

    _defineProperty(_assertThisInitialized(_this9), "name", 'ProviderChainsNotFound');

    _defineProperty(_assertThisInitialized(_this9), "message", ['No chains were found on the wagmi provider. Some functions that require a chain may not work.', '', 'It is recommended to add a list of chains to the provider in `createClient`.', '', 'Example:', '', '```', "import { getDefaultProvider } from 'ethers'", "import { chain, createClient } from 'wagmi'", '', 'createClient({', '  provider: Object.assign(getDefaultProvider(), { chains: [chain.mainnet] })', '})', '```'].join('\n'));

    return _this9;
  }

  return ProviderChainsNotFound;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ResourceUnavailableError = /*#__PURE__*/function (_RpcError2) {
  _inherits(ResourceUnavailableError, _RpcError2);

  var _super11 = _createSuper(ResourceUnavailableError);

  function ResourceUnavailableError(error) {
    var _this10;

    _classCallCheck(this, ResourceUnavailableError);

    _this10 = _super11.call(this, -32002, 'Resource unavailable', error);

    _defineProperty(_assertThisInitialized(_this10), "name", 'ResourceUnavailable');

    return _this10;
  }

  return ResourceUnavailableError;
}(RpcError);

var SwitchChainError = /*#__PURE__*/function (_ProviderRpcError) {
  _inherits(SwitchChainError, _ProviderRpcError);

  var _super12 = _createSuper(SwitchChainError);

  function SwitchChainError(error) {
    var _this11;

    _classCallCheck(this, SwitchChainError);

    _this11 = _super12.call(this, 4902, 'Error switching chain', error);

    _defineProperty(_assertThisInitialized(_this11), "name", 'SwitchChainError');

    return _this11;
  }

  return SwitchChainError;
}(ProviderRpcError);

var SwitchChainNotSupportedError = /*#__PURE__*/function (_Error10) {
  _inherits(SwitchChainNotSupportedError, _Error10);

  var _super13 = _createSuper(SwitchChainNotSupportedError);

  function SwitchChainNotSupportedError(_ref4) {
    var _this12;

    _classCallCheck(this, SwitchChainNotSupportedError);

    var connector = _ref4.connector;
    _this12 = _super13.call(this, "\"".concat(connector.name, "\" does not support programmatic chain switching."));

    _defineProperty(_assertThisInitialized(_this12), "name", 'SwitchChainNotSupportedError');

    return _this12;
  }

  return SwitchChainNotSupportedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserRejectedRequestError = /*#__PURE__*/function (_ProviderRpcError2) {
  _inherits(UserRejectedRequestError, _ProviderRpcError2);

  var _super14 = _createSuper(UserRejectedRequestError);

  function UserRejectedRequestError(error) {
    var _this13;

    _classCallCheck(this, UserRejectedRequestError);

    _this13 = _super14.call(this, 4001, 'User rejected request', error);

    _defineProperty(_assertThisInitialized(_this13), "name", 'UserRejectedRequestError');

    return _this13;
  }

  return UserRejectedRequestError;
}(ProviderRpcError);

var Connector = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  var _super15 = _createSuper(Connector);

  /** Unique connector id */

  /** Connector name */

  /** Chains connector supports */

  /** Options to use with connector */

  /** Whether connector is usable */
  function Connector(_ref) {
    var _this14;

    _classCallCheck(this, Connector);

    var _ref$chains = _ref.chains,
        chains = _ref$chains === void 0 ? defaultChains : _ref$chains,
        options = _ref.options;
    _this14 = _super15.call(this);

    _defineProperty(_assertThisInitialized(_this14), "id", void 0);

    _defineProperty(_assertThisInitialized(_this14), "name", void 0);

    _defineProperty(_assertThisInitialized(_this14), "chains", void 0);

    _defineProperty(_assertThisInitialized(_this14), "options", void 0);

    _defineProperty(_assertThisInitialized(_this14), "ready", void 0);

    _this14.chains = chains;
    _this14.options = options;
    return _this14;
  }

  _createClass(Connector, [{
    key: "getBlockExplorerUrls",
    value: function getBlockExplorerUrls(chain) {
      var _chain$blockExplorers;

      var _ref5 = (_chain$blockExplorers = chain.blockExplorers) !== null && _chain$blockExplorers !== void 0 ? _chain$blockExplorers : {},
          blockExplorer = _ref5["default"],
          blockExplorers = _objectWithoutProperties(_ref5, ["default"]);

      if (blockExplorer) return [blockExplorer.url].concat(_toConsumableArray(Object.values(blockExplorers).map(function (x) {
        return x.url;
      })));
      return [];
    }
  }, {
    key: "isChainUnsupported",
    value: function isChainUnsupported(chainId) {
      return !this.chains.some(function (x) {
        return x.id === chainId;
      });
    }
  }]);

  return Connector;
}(EventEmitter);

export { AddChainError as A, ConnectorAlreadyConnectedError as C, ProviderChainsNotFound as P, ResourceUnavailableError as R, SwitchChainNotSupportedError as S, UserRejectedRequestError as U, _defineProperty as _, ChainDoesNotSupportMulticallError as a, ContractMethodNoResultError as b, ConnectorNotFoundError as c, ChainMismatchError as d, Connector as e, ChainNotConfiguredError as f, ProviderRpcError as g, RpcError as h, SwitchChainError as i, _classPrivateFieldInitSpec as j, _classPrivateFieldGet as k, _classPrivateFieldSet as l, _classPrivateMethodInitSpec as m, normalizeChainId as n, _classPrivateMethodGet as o };